/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { useLocale } from "@epic-mw/i18n";
import { isLangRtl, Direction } from "../utils/direction.utils";

export const useDirection = (): Direction => {
	const locale = useLocale();
	const isRtl = isLangRtl(locale);

	return isRtl ? "rtl" : "ltr";
};

export const useIsRtl = (): boolean => {
	const locale = useLocale();
	const isRtl = isLangRtl(locale);

	return isRtl;
};
